<section class="py-3 card card-div">
  <div class="container-fluid sticky-header-wrapper">
    <div class="d-flex row justify-content-between align-items-center pb-2 g-3">
      <div class="col-12 col-md-6 sku-ledger-widget d-flex flex-column align-items-start">
        <div class="sku-badge px-3 px-md-4 py-2 mb-2 d-inline-block">
          <h2 class="sku-name fw-bold m-0 text-break">Day Book</h2>
        </div>
        @if (isBranchVisible) {
          <span class="footer-text text-muted small">{{selectedBranch}}</span>
        }
      </div>

      <div class="col-12 col-md-6 d-flex align-items-center gap-2 justify-content-start justify-content-md-end flex-wrap">

        <div #dateContainer class="date-picker-wrapper position-relative">
          <button type="button" class="btn action-btn py-2 px-3 d-flex align-items-center gap-2"
            (click)="dp.toggle()">
            <fa-icon [icon]="faCalendar" class="text-muted"></fa-icon>
            {{ currentDate | date:'dd MMM yyyy' }}
          </button>
          <input class="datepicker-hidden-input" name="dp" ngbDatepicker #dp="ngbDatepicker"
            [positionTarget]="dateContainer" [maxDate]="ngbMaxDate" [startDate]="currentNgbDate"
            [(ngModel)]="currentNgbDate" (dateSelect)="onDateSelect($event)">
        </div>

          @if (isBranchVisible) {
            <div class="branch-select-wrapper" style="min-width: 180px;">
              <ng-select [items]="branches" bindLabel="name" bindValue="_id" [(ngModel)]="selectedBranchId"
                (change)="onSelectBranch($event)" [clearable]="false" [searchable]="true">
                <ng-template ng-label-tmp let-item="item">
                  <fa-icon [icon]="faBuilding" class="text-muted me-2"></fa-icon>
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          }

          <button class="btn export-btn py-2 px-3 d-flex align-items-center gap-2"  (click)="openExportListSidebar(exportPanel)">
            <fa-icon [icon]="faDownload"></fa-icon> Export
          </button>        
      </div>
    </div>
  </div>

  <div class="container-fluid">

    <div class="summary-cards-container">
      @for (card of summaryCards; track card) {
        <div class="summary-card-wrapper">
          <div class="summary-card h-100 cursor-pointer" (click)="onCardClick(card.title)">
            <div class="card-header-row">
              <span class="card-title">{{ card.title }}</span>
              <fa-icon [icon]="card.icon" class="card-icon"></fa-icon>
            </div>
            <div class="card-value">
              @if (card.useKFormat) {
                ₹{{ card.value | shortNumber }}
              } @else {
                ₹{{ card.value | number }}
              }
            </div>
            <div class="card-footer-row">
              @if (!card.hidePercentage) {
                <span class="footer-percentage"
                  [ngClass]="card.isNegative ? 'text-red' : 'text-green'">
                  <fa-icon [icon]="card.isNegative ? faArrowTrendDown : faArrowTrendUp" style="font-size: 10px;"></fa-icon>
                  {{ card.footerValue | number:'1.0-2' }}%
                </span>
              }
              <span class="footer-label">{{ card.footerLabel }}</span>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="row g-2">
      <div class="col-12 col-md-8">
        <app-day-book-sales [totalInvoices]="totalInvoices" [selectedDate]="currentDate" [selectedBranch]="selectedBranchId" [branches]="branches" [isBranchVisible]="isBranchVisible"></app-day-book-sales>

        <div class="mt-2 row g-2 align-items-stretch" [class.d-none]="!hasReturnsFromCustomer && !hasReturnsToDealer">
          <div class="col-12 d-flex flex-column" 
            [class.col-md-6]="hasReturnsToDealer" 
            [class.col-md-12]="!hasReturnsToDealer"
            [class.d-none]="!hasReturnsFromCustomer">
            <app-day-returns-from-customer class="h-100 d-block" [selectedDate]="currentDate"
              [selectedBranch]="selectedBranchId" (hasData)="hasReturnsFromCustomer = $event"></app-day-returns-from-customer>
          </div>
        
          <div class="col-12 d-flex flex-column" 
            [class.col-md-6]="hasReturnsFromCustomer" 
            [class.col-md-12]="!hasReturnsFromCustomer"
            [class.d-none]="!hasReturnsToDealer">
            <app-day-returns-to-dealer class="h-100 d-block" [selectedDate]="currentDate"
              [selectedBranch]="selectedBranchId" (hasData)="hasReturnsToDealer = $event"></app-day-returns-to-dealer>
          </div>
        </div>

        @if (isBranchVisible) {
          <div class="mt-2 row">
            <div class="col-12">
              <app-day-transfers-to-branch [selectedDate]="currentDate" [isCompanyView]="isBranchVisible"
                  [selectedBranch]="selectedBranchId"></app-day-transfers-to-branch>
            </div>
          </div>
        } @else {
          <div class="mt-2 row g-2 align-items-stretch">
            <div class="col-12 col-md-6 d-flex flex-column">
              <app-day-transfers-from-branch class="h-100 d-block" [selectedDate]="currentDate"
                [selectedBranch]="selectedBranchId"></app-day-transfers-from-branch>
            </div>
            <div class="col-12 col-md-6 d-flex flex-column">
              <app-day-transfers-to-branch class="h-100 d-block" [selectedDate]="currentDate" [isCompanyView]="isBranchVisible"
                  [selectedBranch]="selectedBranchId"></app-day-transfers-to-branch>
            </div>
          </div>
        }

        <div class="mt-2 row g-2 align-items-stretch">
          <div class="col-12 col-md-6 d-flex flex-column">
            <app-day-book-expenses class="h-100 d-block" [selectedDate]="currentDate" [selectedBranch]="selectedBranchId"></app-day-book-expenses>
          </div>

          <div class="col-12 col-md-6 d-flex flex-column">
            <app-day-book-services class="h-100 d-block" [selectedDate]="currentDate" [selectedBranch]="selectedBranchId"></app-day-book-services>
          </div>
        </div>

        <div class="mt-3">
          <app-stock-movement [selectedDate]="currentDate" [selectedBranch]="selectedBranchId"></app-stock-movement>
        </div>

        <div class="mt-3">
          <app-day-purchases [selectedDate]="currentDate" [selectedBranch]="selectedBranchId"></app-day-purchases>
        </div>
      </div>

      <div class="col-12 col-md-4">
        <div>
          <app-negative-stock [selectedDate]="currentDate" [selectedBranch]="selectedBranchId"></app-negative-stock>
        </div>

        <div class="mt-2">
          <app-day-book-payments [selectedDate]="currentDate" [selectedBranch]="selectedBranchId"></app-day-book-payments>
        </div>

        <div class="mt-2">
          <app-day-cash-summary [selectedDate]="currentDate" [selectedBranch]="selectedBranchId"></app-day-cash-summary>
        </div>

        <div class="mt-2">
          <app-risks-alerts [selectedDate]="currentDate" [selectedBranch]="selectedBranchId"></app-risks-alerts>
        </div>
      </div>
    </div>

  </div>
</section>

<ng-template #exportPanel let-offcanvas>
  <div class="panel-wrapper d-flex flex-column h-100">

    <div class="panel-header flex-shrink-0">
      <h4 class="panel-title fw-bold m-0 text-dark">Export History</h4>
      <div class="d-flex align-items-center gap-2">
        <button class="btn export-btn d-flex align-items-center gap-2" (click)="exportDayBook()">
          <fa-icon [icon]="faDownload" [size]="'sm'"></fa-icon> Export
        </button>
        <button class="btn fw-bold filter-toggle flex-grow-1 flex-md-grow-0" (click)="refreshExportList()">
          <fa-icon class="me-1 text-dark" [icon]="faRotate" size="sm"></fa-icon>
          <span class="text-dark fw-bold small">Refresh</span>
        </button>
        <button type="button" class="panel-close-btn ms-2" (click)="offcanvas.dismiss()">
          &#x2715;
        </button>
      </div>
    </div>

    <div class="panel-body flex-grow-1 overflow-auto p-0"
         infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2"
         [infiniteScrollThrottle]="500" (scrolled)="onScrollExportList()">
      
      <div class="table-responsive px-md-1">
        <table class="table custom-table align-middle m-0">
          <thead>
            <tr>
              <th>FILE NAME</th>
              <th>STATUS</th>
              <th>EXPORTED BY</th>
              <th>DATE</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          @if (exportList.length >= 1) {
            <tbody>
              @for (item of exportList; track item) {
                <tr class="normal-row">
                  <td class="table-text-one text-break" style="max-width: 150px;">{{ item.fileName }}</td>
                  <td class="table-text-one">
                    <span class="badge px-2 py-1 rounded" [ngClass]="{
                      'bg-success': item.status === 'Completed',
                      'bg-danger': item.status === 'Failed',
                      'bg-warning text-dark': item.status === 'Pending' || item.status === 'Processing'
                    }">{{ item.status }}</span>
                  </td>
                  <td class="table-text-two">{{ item.createdBy?.name || 'N/A' }}</td>
                  <td class="table-text-one">
                    {{item.created | date: "dd-MM-yyyy hh:mm:ss a" : "Asia/Kolkata" }}
                  </td>
                  <td class="table-text-one">
                    <button class="btn btn-sm app-btn-primary" (click)="viewPdf(item, pdfModal)" [disabled]="!item.fileUrl && !item.sheetUrl"
                      [title]="(item.fileUrl || item.sheetUrl) ? 'Download PDF' : 'No pdf available'">
                      <fa-icon [icon]="faEye" size="sm"></fa-icon>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
      </div>

      @if (listLoader) {
        <div class="d-flex justify-content-center p-3">
          <app-loader [loadingIcon]="listLoader"></app-loader>
        </div>
      }

      @if (listErrMsg) {
      <div class="alert alert-danger m-3 py-2 small">
        {{ listErrMsg }}
      </div>
      }

      @if (!listLoader && !listErrMsg && exportList.length === 0) {
        <div class="text-muted text-center p-4">
          No Records Found!
        </div>
      }
      
    </div>

  </div>
</ng-template>

<!-- PDF Viewer Modal -->
<ng-template #pdfModal let-modal>
  <div class="app-pdf-model">
    <div class="modal-header border-0 pb-2 d-flex justify-content-between align-items-center">
      <h4 class="fw-bold mb-0 text-dark heading-text">{{ selectedVoucher.name }}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body p-0">
      <iframe [src]="selectedVoucher.url" class="pdf-iframe" title="PDF Document Viewer"></iframe>
    </div>
  </div>
</ng-template>

@if(errMsg){
  <app-toaster [title]="errMsg" (closeToaster)="closeToster()"></app-toaster>
}